import * as React from 'react';

import * as Sebrae from '@sebrae/react-core';

export function useIsModuleRoute() {
  const { isInRoute } = Sebrae.useRouter();

  const isModuleRoute = React.useCallback(
    <T extends Record<string, string>>(routePath: T) => {
      return Object.values(routePath).some((pattern: string) =>
        isInRoute(pattern),
      );
    },
    [isInRoute],
  );

  return {
    isModuleRoute,
  };
}
